/* login */
export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const SET_LOGOUT_ANIMATION = "SET_LOGOUT_ANIMATION";
export const LOGIN_TYPE = "LOGIN_TYPE";
export const SET_LOGIN_ANIMATION = "SET_LOGIN_ANIMATION";

/* mail recovery*/
export const RECOVERY_START = "RECOVERY_START";
export const RECOVERY_SUCCESS = "RECOVERY_SUCCESS";
export const RECOVERY_FAIL = "RECOVERY_FAIL";
export const SET_SUCCESS_FALSE = "SET_SUCCESS_FALSE";

/* Register */

export const REGISTER_START = "REGISTER_START";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const VALIDATION_SUCCESS = "VALIDATION_SUCCESS";
export const SET_IS_VALIDATING = "SET_IS_VALIDATING";
export const OPEN_IDENTITY_MODAL = "OPEN_IDENTITY_MODAL";

/* New Registration Flow */
export const PRE_REGISTER_START = "PRE_REGISTER_START";
export const PRE_REGISTER_SUCCESS = "PRE_REGISTER_SUCCESS";
export const PRE_REGISTER_FAIL = "PRE_REGISTER_FAIL";
export const CODE_VALIDATION_START = "CODE_VALIDATION_START";
export const CODE_VALIDATION_SUCCESS = "CODE_VALIDATION_SUCCESS";
export const CODE_VALIDATION_FAIL = "CODE_VALIDATION_FAIL";
export const RESEND_CODE_START = "RESEND_CODE_START";
export const RESEND_CODE_SUCCESS = "RESEND_CODE_SUCCESS";
export const RESEND_CODE_FAIL = "RESEND_CODE_FAIL";

export const CLEAR_REGISTRATION_FLOW = "CLEAR_REGISTRATION_FLOW";

// Nuevos tipos para completar registro
export const COMPLETE_REGISTRATION_START = "COMPLETE_REGISTRATION_START";
export const COMPLETE_REGISTRATION_SUCCESS = "COMPLETE_REGISTRATION_SUCCESS";
export const COMPLETE_REGISTRATION_FAIL = "COMPLETE_REGISTRATION_FAIL";

/*Set new password recovery */
export const SET_NEW_RECOVERY_PASSWORD = "SET_NEW_RECOVERY_PASSWORD";

/* Login Token */
export const SET_ACCESS = "SET_ACCESS";

/*Loading */
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";

/* User Data */
export const GET_DATA = "GET_DATA";
export const SET_USER_DESCRIPTION = "SET_USER_DESCRIPTION";
export const SET_USER_SKILLS = "SET_USER_SKILLS";
export const SET_PERSONA_DATA = "SET_PERSONA_DATA";
export const SET_PERSONA_FORM = "SET_PERSONA_FORM";
export const SET_EMPRESA_DATA = "SET_EMPRESA_DATA";
export const SET_EMPRESA_FORM = "SET_EMPRESA_FORM";
export const CLEAR_ONBOARDING_FORM = "CLEAR_ONBOARDING_FORM";
export const GET_USER_ACTIVITY_SUMMARY = "GET_USER_ACTIVITY_SUMMARY";

/**MODAL OPEN */
export const CLOSE_MODAL = "CLOSE_MODAL";

/* SideNavBar state */

export const EXPANDED_SIDEBAR = "EXPANDED_SIDEBAR";

/* Main Modal */
export const OPEN_MAIN_MODAL = "OPEN_MAIN_MODAL";
export const CLOSE_MAIN_MODAL = "CLOSE_MAIN_MODAL";

/* Loaders */
export const OPEN_EDIFY_SPINNER = "OPEN_EDIFY_SPINNER";
export const CLOSE_EDIFY_SPINNER = "CLOSE_EDIFY_SPINNER";
export const PROGRESS_BAR_LOADER = "PROGRESS_BAR_LOADER";

/* NDA Modal*/
export const OPEN_NDA_MODAL = "OPEN_NDA_MODAL";
export const CLOSE_NDA_MODAL = "CLOSE_NDA_MODAL";

//Contact notification modal
export const OPEN_SEND_CONTACT_NOTIFICATION_MODAL = "OPEN_SEND_CONTACT_NOTIFICATION_MODAL";
export const CLOSE_SEND_CONTACT_NOTIFICATION_MODAL = "CLOSE_SEND_CONTACT_NOTIFICATION_MODAL";

//Calification Modal
export const OPEN_CALIFICATION_MODAL = "OPEN_CALIFICATION_MODAL";
export const CLOSE_CALIFICATION_MODAL = "CLOSE_CALIFICATION_MODAL";

// Feed Text Modal
export const OPEN_FEED_TEXT_MODAL = "OPEN_FEED_TEXT_MODAL";
export const CLOSE_FEED_TEXT_MODAL = "CLOSE_FEED_TEXT_MODAL";

/* Tipe Manager */
export const CHANGE_TYPE = "CHANGE_TYPE";

/* SET FILE ACTION */
export const SET_FILE = "SET_FILE";

/* PORTFOLIO */
export const SET_PORTFOLIO = "SET_PORTFOLIO";
export const GET_PORTFOLIO_LOADING = "GET_PORTFOLIO_LOADING";
export const EDIT_PORTFOLIO = "EDIT_PORTFOLIO";
export const SEARCH_SKILL = "SEARCH_SKILL";
export const SET_SKILLS_LIST = "SET_SKILLS_LIST";
export const SET_SKILLS = "SET_SKILLS";
export const GET_USER_SKILL = "GET_USER_SKILL";
export const CLEAR_USER_SKILLS = "CLEAR_USER_SKILLS";
export const ADD_SKILL = "ADD_SKILL";
export const REMOVE_SKILL = "REMOVE_SKILL";
export const SET_USERS_BY_SKILL = "SET_USERS_BY_SKILL";
export const RESET_SELECTEDSKILL = "RESET_SELECTEDSKILL";
export const SET_USERS_IN_SKILL_NAME = "SET_USERS_IN_SKILL_NAME";
export const SET_USERS_IN_JURISDICTION = "SET_USERS_IN_JURISDICTION";
export const GET_PORTFOLIO_QUESTIONS = "GET_PORTFOLIO_QUESTIONS";

/* SUSCRIPTION */
export const GET_PLANS = "GET_PLANS";
export const GET_USER_PLAN = "GET_USER_PLAN";
export const SET_PLANID = "SET_PLANID";
export const SEND_PLAN = "SEND_PLAN";
export const SET_TERMINOS = "SET_TERMINOS";
export const SET_SUCCESS = "SET_SUCCESS";

/* TUTORIAL */
export const CLOSE_TUTORIAL_MODAL = "CLOSE_TUTORIAL_MODAL";   
export const OPEN_TUTORIAL_MODAL = "OPEN_TUTORIAL_MODAL";
export const SET_TUTORIAL_STEP = "SET_TUTORIAL_STEP";
export const SET_TUTORIAL_COMPLETED = "SET_TUTORIAL_COMPLETED";
export const RESET_TUTORIAL = "RESET_TUTORIAL";
export const SKIP_TUTORIAL = "SKIP_TUTORIAL";

/* PROFILE */

export const SET_NEW_PROFILE_IMAGE = "SET_NEW_PROFILE_IMAGE";
export const SET_OPEN_MAIN_ID = "SET_OPEN_MAIN_ID";
export const SET_NEWSKILL_TO_LIST = "SET_NEWSKILL_TO_LIST"; 
export const OPEN_SHARE_PROFILE = "OPEN_SHARE_PROFILE";
export const OPEN_PROFILE_MENU = "OPEN_PROFILE_MENU";
export const GET_SUBPROJECT_BUDGETS = "GET_SUBPROJECT_BUDGETS";
export const CLEAR_SUBPROJECT_BUDGETS = "CLEAR_SUBPROJECT_BUDGETS";
export const OPEN_EDIT_PROFILE_DATA = "OPEN_EDIT_PROFILE_DATA";
export const CLOSE_EDIT_PROFILE_DATA = "CLOSE_EDIT_PROFILE_DATA";
export const PROFILE_DATA_OF_USER_SENDER = "PROFILE_DATA_OF_USER_SENDER";
export const OPEN_EDIT_PROFILE_SKILL = "OPEN_EDIT_PROFILE_SKILL";
export const CLOSE_EDIT_PROFILE_SKILL = "CLOSE_EDIT_PROFILE_SKILL";
export const SET_GO_BACK_TO_CATEGORY_LIST = "SET_GO_BACK_TO_CATEGORY_LIST";
export const GET_POSTULATIONS = "GET_POSTULATIONS";
export const GET_POSTULATIONS_LOADING = "GET_POSTULATIONS_LOADING";
export const SET_PROJECT_TO_EDIT = "SET_PROJECT_TO_EDIT";
export const RESET_PROJECT_TO_EDIT = "RESET_PROJECT_TO_EDIT";
export const SET_LIKES = "SET_LIKES";
export const GET_VISITS = "GET_VISITS";
export const GET_PROJECTS = "GET_PROJECTS";
export const GET_PROJECTS_LOADING = "GET_PROJECTS_LOADING";
export const SET_SUBPROJECT_ID = "SET_SUBPROJECT_ID";
export const MY_DATA = "MY_DATA";
export const GET_COMMENTS = "GET_COMMETS";
export const POST_COMMENT = "POST_COMMENT";
export const COMMENT_POSTED = "COMMENT_POSTED";
export const SET_QUOTATION_TO_EDIT = "SET_QUOTATION_TO_EDIT";

/* DASHBOARD */

export const GET_DASHBOARD_PROJECTS = "GET_DASHBOARD_PROJECTS";
export const GET_TOTAL_USERS = "GET_TOTAL_USERS";
export const GET_LAST_NEW_USERS = "GET_LAST_NEW_USERS";
export const GET_TOTAL_PUBLIC_PROJECTS = "GET_TOTAL_PUBLIC_PROJECTS";
export const GET_TOTAL_PRIVATE_PROJECTS = "GET_TOTAL_PRIVATE_PROJECTS";
export const GET_TOTAL_ADJUDICATED_PROJECTS = "GET_TOTAL_ADJUDICATED_PROJECTS";
export const GET_LAST_ADJUDICATED_PROJECT = "GET_LAST_ADJUDICATED_PROJECT";
export const GET_TOTAL_NEW_PRIVATE_QUOTATIONS = "GET_TOTAL_NEW_PRIVATE_QUOTATIONS";
export const GET_TOTAL_PUBLIC_QUOTATIONS = "GET_TOTAL_PUBLIC_QUOTATIONS";
export const GET_TOTAL_NEW_PUBLIC_QUOTATIONS = "GET_TOTAL_NEW_PUBLIC_QUOTATIONS";
export const GET_TOTAL_PRIVATE_QUOTATIONS = "GET_TOTAL_PRIVATE_QUOTATIONS";
export const SET_PROFILE_VISUALIZER = "SET_PROFILE_VISUALIZER";
export const SET_LOCATION = "SET_LOCATION";
export const CLEAR_LOCATION = "CLEAR_LOCATION";
export const CLEAR_PROJECTS = "CLEAR_PROJECTS";
export const GET_DASHBOARD_PROJECTS_LOADING = "GET_DASHBOARD_PROJECTS_LOADING";
export const SET_PREVIOUS_LOCATION = "SET_PREVIOUS_LOCATION";
export const GET_ALL_PORTFOLIOS = "GET_ALL_PORTFOLIOS";

/* POSTEOS */

export const GET_POSTEOS = "GET_POSTEOS";
export const GET_OWN_POSTEOS = "GET_OWN_POSTEOS";
export const RECENT_POST = "RECENT_POST";
export const GET_POSTEO_COMMENTS = "GET_POSTEO_COMMENTS";
export const GET_POSTEO_WITH_COMMENTS = "GET_POSTEO_WITH_COMMENTS";
export const UPDATE_POSTEO_INFO = "UPDATE_POSTEO_INFO";

/* SUBPROYECT */

export const UPDATE_SUBPROJECTS_LIST = "UPDATE_SUBPROJECTS_LIST";
export const DELETE_SUBPROJECT = "DELETE_SUBPROJECT";
export const SET_PROJECT_ID = "SET_PROJECT_ID";
export const SET_PROJECTSTEP1_ID = "SET_PROJECTSTEP1_ID";
export const GET_SUBPROJECTS_TYPE = "GET_SUBPROJECTS_TYPE";
export const SET_DELETE_SUBPROJECT = "SET_DELETE_SUBPROJECT";
export const SET_EDIT_SUBPROJECT = "SET_EDIT_SUBPROJECT";
export const RESET_SUBPROJECTS = "RESET_SUBPROJECTS";
export const SET_SUBPROJECTS_FROM_EDIT = "SET_SUBPROJECTS_FROM_EDIT";

/* PROYECTO */
export const SET_SEND_PROJECT = "SET_SEND_PROJECT";
export const SET_SEND_SUBPROJECT = "SET_SEND_SUBPROJECT";
export const SET_NEW_SUBPROJECT = "SET_NEW_SUBPROJECT";
export const SET_ID_PROJECT = "SET_ID_PROJECT";
export const RESET_ID_PROJECT = "RESET_ID_PROJECT";
export const GET_PRIVATE_PROJECT_BY_ID = "GET_PRIVATE_PROJECT_BY_ID";
export const SET_PRIVATE_PROJECT_LOADING = "SET_PRIVATE_PROJECT_LOADING";
export const GET_POSTULATION_PROJECT_STATUS = "GET_POSTULATION_PROJECT_STATUS";
export const SET_PUBLIC_PROJECT = "SET_PUBLIC_PROJECT";
export const SET_ADJUDICATED_PUBLIC_PROJECT = "SET_ADJUDICATED_PUBLIC_PROJECT";
export const GET_PROJECT_QUESTIONS = "GET_PROJECT_QUESTIONS";

/* POSTULACIONES */
export const SET_POSTULATION_PROJECT = "SET_POSTULATION_PROJECT";
export const CLEAR_POSTULATION_PROJECT = "CLEAR_POSTULATION_PROJECT";
export const SET_POSTULATION_PROJECT_ID = "SET_POSTULATION_PROJECT_ID";

/* SOLICITUDES */
export const GET_SOLICITUDE_LIST = "GET_SOLICITUDE_LIST";

/* BUDGETS */
export const GET_BUDGETS_LIST = "GET_BUDGETS_LIST";
export const SET_BUDGET_ID = "SET_BUDGET_ID";

/* Skeleton Loading */
export const SKELETON_END = "SKELETON_END";
export const SKELETON_START = "SKELETON_START";

/* COTIZACION */
export const SET_SEND_SUBQUOTATION = "SET_SEND_SUBQUOTATION";
export const SET_NEW_SUBQUOTATION = "SET_NEW_SUBQUOTATION";
export const SET_ID_QUOTATION = "SET_ID_QUOTATION";
export const RESET_ID_QUOTATION = "RESET_ID_QUOTATION";
export const SET_QUOTATION_LOADING = "SET_QUOTATION_LOADING";
export const GET_QUOTATIONS_TYPE = "GET_QUOTATIONS_TYPE";
export const GET_MY_QUOTATIONS = "GET_MY_QUOTATIONS";
export const GET_MY_QUOTATIONS_USERPANEL = "GET_MY_QUOTATIONS_USERPANEL";
export const GET_MY_QUOTATIONS_LOADING = "GET_MY_QUOTATIONS_LOADING";
export const GET_QUOTATION = "GET_QUOTATION";
export const CLEAR_QUOTATIONS = "CLEAR_QUOTATIONS";
export const SET_PUBLIC_QUOTATION = "SET_PUBLIC_QUOTATION";

/* USERS */
export const USERS_REGISTERED_DATA = "USERS_REGISTERED_DATA";
export const USER_CALIFICATIONS = "USER_CALIFICATIONS";
export const USER_CALIFICATIONS_LOADING = "USER_CALIFICATIONS_LOADING";

/* SUBQUOTATION */

export const SET_SUBQUOTATION = "SET_SUBQUOTATION";
export const SET_DELETE_SUBQUOTATION = "SET_DELETE_SUBQUOTATION";
export const GET_SUBQUOTATIONS_TYPE = "GET_SUBQUOTATIONS_TYPE";
export const SHOW_SUBQUOTATIONS = "SHOW_SUBQUOTATIONS";
export const CLEAR_SUBQUOTATIONS = "CLEAR_SUBQUOTATIONS";
export const GET_SUB_QUOTATIONS_POSTULATIONS = "GET_SUB_QUOTATIONS_POSTULATIONS";
export const GET_MATERIALS_SUCCESS = 'GET_MATERIALS_SUCCESS';
export const GET_MATERIALS_FAILURE = 'GET_MATERIALS_FAILURE';


/* SUSCRIPTION */

export const OPEN_SUSCRIPTION_MODAL = "OPEN_SUSCRIPTION_MODAL";
export const CLOSE_SUSCRIPTION_MODAL = "CLOSE_SUSCRIPTION_MODAL";
export const SUSCRIPTION_LOADING = "SUSCRIPTION_LOADING";
export const ACTIVATE_FREE_TRIAL = "ACTIVATE_FREE_TRIAL";
export const CANCEL_SUSCRIPTION_LOADING = "CANCEL_SUSCRIPTION_LOADING";

/* BOLSA DE TRABAJO */

export const GET_ALL_WORKBAG_USERS = "GET_ALL_WORKBAG_USERS";
export const FILTER_WORKBAG_USERS = "FILTER_WORKBAG_USERS";
export const GET_ALL_JOB_REQUESTS = "GET_ALL_JOB_REQUESTS";
export const GET_CITIES = "GET_CITIES";
export const FILTER_WORKBAG_USERS_SUCCESS = "FILTER_WORKBAG_USERS_SUCCESS";
export const FILTER_WORKBAG_USERS_FAILURE = "FILTER_WORKBAG_USERS_FAILURE";
export const CURRENT_WORK_OFFER = "CURRENT_WORK_OFFER";
export const SEND_WORK_OFFER_POSTULATION = "SEND_WORK_OFFER_POSTULATION";
export const FETCH_IDENTITY_PHOTOS_WORKERS_REQUEST = "FETCH_IDENTITY_PHOTOS_WORKERS_REQUEST";
export const FETCH_IDENTITY_PHOTOS_WORKERS_SUCCESS = "FETCH_IDENTITY_PHOTOS_WORKERS_SUCCESS";
export const FETCH_IDENTITY_PHOTOS_WORKERS_FAILURE = "FETCH_IDENTITY_PHOTOS_WORKERS_FAILURE";


/* CATEGORY */
export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_ERROR = "GET_CATEGORIES_ERROR";
export const CREATE_CATEGORY_REQUEST = "CREATE_CATEGORY_REQUEST";
export const CREATE_CATEGORY_SUCCESS = "CREATE_CATEGORY_SUCCESS";
export const CREATE_CATEGORY_ERROR = "CREATE_CATEGORY_ERROR";
export const DELETE_CATEGORY_REQUEST = "DELETE_CATEGORY_REQUEST";
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_ERROR = "DELETE_CATEGORY_ERROR";
export const UPDATE_CATEGORY_REQUEST = "UPDATE_CATEGORY_REQUEST";   
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_ERROR = "UPDATE_CATEGORY_ERROR";
export const RESET_SUCCESS = "RESET_SUCCESS";
export const SEND_QUOTE_FAIL = "SEND_QUOTE_FAIL";
export const SEND_QUOTE_REQUEST = "SEND_QUOTE_REQUEST";
export const SEND_QUOTE_SUCCESS = "SEND_QUOTE_SUCCESS";
export const GET_CATEGORY_LIST = "GET_CATEGORY_LIST";
export const GET_CATEGORY_ERROR = "GET_CATEGORY_ERROR";

/* BACKOFFICE */
export const SET_BACKOFFICE_ACTIVE_TAB = "SET_BACKOFFICE_ACTIVE_TAB";
export const FETCH_PENDING_ANTEPROYECTOS_LOADING = "FETCH_PENDING_ANTEPROYECTOS_LOADING";
export const FETCH_PENDING_ANTEPROYECTOS_SUCCESS = "FETCH_PENDING_ANTEPROYECTOS_SUCCESS";
export const FETCH_PENDING_ANTEPROYECTOS_ERROR = "FETCH_PENDING_ANTEPROYECTOS_ERROR";
export const SET_SELECTED_ANTEPROYECTO = "SET_SELECTED_ANTEPROYECTO";
export const FETCH_BACKOFFICE_STATS_LOADING = "FETCH_BACKOFFICE_STATS_LOADING";
export const FETCH_BACKOFFICE_STATS_SUCCESS = "FETCH_BACKOFFICE_STATS_SUCCESS";
export const SET_BACKOFFICE_FILTERS = "SET_BACKOFFICE_FILTERS";
export const SET_BACKOFFICE_PAGE = "SET_BACKOFFICE_PAGE";
export const VALIDATE_ANTEPROYECTO_LOADING = "VALIDATE_ANTEPROYECTO_LOADING";
export const VALIDATE_ANTEPROYECTO_SUCCESS = "VALIDATE_ANTEPROYECTO_SUCCESS";
export const VALIDATE_ANTEPROYECTO_ERROR = "VALIDATE_ANTEPROYECTO_ERROR";